<template>
	<transition appear name="fade">
  <header class="contact text-mono">
	  <prismic-rich-text :field="contact"/>
  </header>
	</transition>
</template>

<script>

export default {
  name: 'Contact',
  data () {
	  return {
		  contact: null
	  };
  },
  methods: {
	  getContent () {
		  this.$prismic.client.getSingle('site')
		  	.then((document) => {
			  	this.contact = document.data.contact
		  	})
	  }
  },
  created () {
	  this.getContent();
  },
  mounted () {
  }
}

</script>

<style scoped>

</style>
